{
  "Clear search": "Obriši pretragu"
}